import axios  from "@/utils/request";

// 行政区划字典
export const getAreaOptions = () => {
    return axios({
        path: '/onlineMedical/medicalComp/dict/areaOptions',
        method: 'get',
    })
}

// 基本信息的部门选项
export const getDeptDictList = (data:any) => {
    return axios({
        path: '/onlineMedical/medicalComp/dict/getDeptDictList',
        data
    })
}


// 经济类型
export const getJingJIZiDian = () => {
    return axios({
        path: '/admin/dict/type/ts_5',
        method: 'get',
    })
}
//身份证件类型
export const getShenFenZhengZiDian = () => {
    return axios({
        path: '/admin/dict/type/ts_4',
        method: 'get',
    })
}

// 申请类别
export const getShenQingZiDian =() => {
    return axios({
        path: '/admin/dict/type/ts_8',
        method: 'get',
    })
}

// 专业职称详细-监督类别
export const getJianDuLeiBie = () =>{
    return axios({
        path: '/admin/dict/tscode',
        method: 'get',
    })
}


// 医疗卫生单位类别
export const getYiliao = () => {
  return axios({
      path: '/admin/dict/ts/06',
    method: 'get',
  })
}







